import React, {useState} from 'react';
import CoverLoading from "../components/cover-loading";
import Filter from "../components/filter";
import {Link} from "react-router-dom";
import Card from "../components/card";

const Apartment = () => {
    const [post,setPost] = useState([])
    const [loading,setLoading] = useState(false)
    return (
        <div className='main-container justify-content-start'>
            {loading ? <CoverLoading/> : ''}
            <Filter path='apartment' setPost={setPost} setLoading={setLoading}/>
            <div className="row justify-content-end">
                <div className="col-2">
                    <Link to={'/add-apartment'} className='btn btn-primary'>Create Apartment</Link>
                </div>
            </div>
            <div className="list-posts">
                {post.map((e)=><Card path='apartment' post={post} setPost={setPost} setLoading={setLoading} key={e.id} data={e}/>)}
            </div>
        </div>
    );
};

export default Apartment;